import { createFileRoute } from "@tanstack/react-router";
import DealerVanzareGuide from "@/pages/ghiduri/DealerVanzareGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/cum-vand-dealerii-mai-repede/")({
  head: () => routeHead("/ghiduri/cum-vand-dealerii-mai-repede/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealerVanzareGuide />
  );
}
